<input
  #stringInput
  [formControl]="geoPointFormControl"
  type="text"
  class="string-input"
  placeholder="Lat°, Long°"
  [ngStyle]="config?.inputStyles"
  (beforeinput)="geoPointInputTransformFn($event, geoPointFormControl)"
  (paste)="geoPointPasteFn($event, geoPointFormControl)"
  (blur)="geoPointValueBlurFn(geoPointFormControl)"
/>
